<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Withdrawal') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to initiate a withdrawal</span>
            </div>

            <step-container
                :current_step="3"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
        
            <b-row>
                <b-col cols="12" md="8" class="mx-auto">
                    <div id="body-container" v-if="update_beneficiary">
                        <div class="p-0 pb-3 text-center">
                            <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`" style="background-color: #EDF8F1;border-radius: 20px;">
                            <h5 class="my-3">Resubmit Withdrawal (Same Name)</h5>
                            <hr/>
                            <div class="d-flex mb-3">
                                <div>Account Type</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.accType==1?'Business':'Individual' }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Currency</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.accountCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Name</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Card Number</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Name</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.bankName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Branch Name</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.bankBranchName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Country</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.currentCountry }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Swift Code</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.swiftCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank code</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.clearingCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Beneficiary Address</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.payeeAddress }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Address</div>
                                <div class="ml-auto fw-700">{{ update_beneficiary.bankAddress }}</div>
                            </div>
                            <hr/>
                        </div>

                        <div class="p-0 pb-5 text-center">
                            <div class="d-flex mb-3">
                                <div>Payee Account Name</div>
                                <div class="ml-auto fw-700">{{ withdrawal_application.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payee Card Number</div>
                                <div class="ml-auto fw-700">{{ withdrawal_application.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payee Currency</div>
                                <div class="ml-auto fw-700">{{ withdrawal_application.payeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank charges to be borne</div>
                                <div class="ml-auto fw-700">{{ getCostBorne(withdrawal_application.costBorne) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Type</div>
                                <div class="ml-auto fw-700">{{ getType(withdrawal_application.fixedModel) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Amount</div>
                                <div class="ml-auto fw-700">{{ withdrawal_application.paymentCcy }} {{ (withdrawal_application.fixedModel == 1)?getAmount(withdrawal_application.paymentAmount):getAmount(withdrawal_application.payeeAmount) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Purpose of Payment</div>
                                <div class="ml-auto fw-700">{{ getPurpose(withdrawal_application.paymentPurpose) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Fee</div>
                                <div class="ml-auto fw-700">USD {{ getAmount(withdrawal_application.paymentFee) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Fee Currency</div>
                                <div class="ml-auto fw-700">{{ withdrawal_application.paymentFeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Reference</div>
                                <div class="ml-auto fw-700">{{ withdrawal_application.paymentReference }}</div>
                            </div>
                            <hr/>
                            <div class="d-flex mb-0">
                                <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                                <button @click="$bvModal.show('modal-payment-password');" class="btn btn-primary d-block">{{ $t('Submit') }}</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        
      </b-container>
      <b-modal id="modal-payment-password" hide-footer hide-title>
        <PaymentPassword @on-submit="validatePin"></PaymentPassword>
      </b-modal>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import PaymentPassword from "@/components/PaymentPassword";
    import Global from '@/services/Global';
    import Withdrawal from "@/services/Withdrawal";
    import Common from "@/services/Common";
  
    export default {
        name: 'resubmit-withdrawal-summary',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                withdrawal_application: null,
                update_beneficiary:null,
                fixedModelList:{
                    1:"Foreign Exchange Account",
                    2:"Receiving Account"
                },
                paymentPurposeOpt:{
                    1:"current settlement",
                    2:"loan",
                    3:"travel expenses",
                    4:"living expenses",
                    5:"investment funds",
                    6:"office expenses",
                    7:"engineering funds",
                    8:"labor costs/salaries",
                    9:"tuition fees",
                    10:"others"
                },
                costBorneOpt:{
                    "OUR":"OUR (sender pays all charges)",
                    "SHA":"SHA (shared charges)"
                },
                stepList:["Select Withdrawal","Fill Information", "Withdrawal Summary"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            PaymentPassword
        },
        methods:{
            validatePin(pin){
                let self = this;
                this.isLoading = true;
                Common.validate_payment_password({
                    "securitycode":pin.join(""),
                }).then(response=>{
                    if(response.status==200){
                        this.$bvModal.hide('modal-payment-password');
                        this.doSubmit();
                    }
                }).catch(err => {
                    self.isLoading = false;
                    this.checkError(err);
                });
            },
            getCostBorne(type){
                return this.costBorneOpt[type];
            },
            getPurpose(type){
                return this.paymentPurposeOpt[parseInt(type)];
            },
            getType(type){
                return this.fixedModelList[parseInt(type)];
            },
            getAmount(amount){
                return Global.addCommas(amount);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            resubmitWithdrawal(){
                let self = this;
                Withdrawal.submitWithdrawal({
                    withdrawal_id:parseInt(this.$route.query.id),
                    benificiaryId:this.withdrawal_application.benificiaryId,
                    fixedModel:parseInt(this.withdrawal_application.fixedModel),
                    paymentCcy:this.withdrawal_application.paymentCcy,
                    paymentAmount:this.withdrawal_application.paymentAmount,
                    payeeAmount:this.withdrawal_application.payeeAmount,
                    paymentPurpose:this.withdrawal_application.paymentPurpose,
                    paymentReference:this.withdrawal_application.paymentReference,
                    costBorne:this.withdrawal_application.costBorne,
                    paymentFeeCcy:this.withdrawal_application.paymentFeeCcy
                }).then((response)=>{
                    if (response.status == 200) {
                        self.isLoading = false;
                        let data = response.data.data;
                        localStorage.removeItem("update_withdrawal");
                        localStorage.removeItem("update_beneficiary");
                        self.$swal({
                            icon: 'success',
                            title: self.getMessage('Success'),
                            showConfirmButton: true,
                        }).then((result) => {
                            self.$router.push({ 
                                path: '/withdrawal', 
                            });
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    self.checkError(err);
                });
            },
            doSubmit(){
                let self = this;
                this.isLoading = true;
                // pertama update beneficiary

                Withdrawal.updateBeneficiary({
                    "benificiary_id":this.withdrawal_application.benificiaryId,
                    "accType":self.update_beneficiary.accType,
                    "accountCcy": self.update_beneficiary.accountCcy,
                    "accountName": self.update_beneficiary.accountName,
                    "cardNo": self.update_beneficiary.cardNo,
                    "bankName": self.update_beneficiary.bankName,
                    "bankBranchName": self.update_beneficiary.bankBranchName,
                    "countryCode": self.update_beneficiary.countryCode,
                    "swiftCode": self.update_beneficiary.swiftCode,
                    "payeeAddress": self.update_beneficiary.payeeAddress,
                    "bankAddress": self.update_beneficiary.bankAddress,
                    "clearingCode": self.update_beneficiary.clearingCode
                }).then((response)=>{
                    if (response.status == 200) {
                       self.resubmitWithdrawal(); 
                    }
                }).catch((err) => {
                    console.log(err);
                    self.checkError(err);
                });
            },
            checkError(err){
                this.isLoading = false;
                const response = err.response;  

                let self = this;
                if(response.status == 400 || response.status == 500){
                    try{
                        response.data.message = JSON.parse(response.data.message);
                    }
                    catch(e){
                        console.log("");
                    }

                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                ret.push(response.data.message[key][0]);
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }
        },
        mounted(){
            const withdrawal_application = JSON.parse(localStorage.getItem('update_withdrawal'));
            this.withdrawal_application = withdrawal_application;

            this.update_beneficiary = localStorage.getItem("update_beneficiary");
            this.update_beneficiary = JSON.parse(this.update_beneficiary);
        }
    };
  </script>

<style scoped>
ul li{
    list-style: disc;
}
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
.account-type:hover{
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}
.block-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
hr{
    border-style: dashed;
}
</style>